module.exports = __webpack_public_path__ + "img/Mongolia.689454b5.svg";